import React, { useState } from "react";
import "./window-card.scss";

// UJI components
import Button from "../button/button";
import { CaretDownIcon } from "../../../utils/svgs";

// Returns the markup for a modal window block
export default function WindowCard({ id, className, title, subtitle, primaryAction, secondaryAction, stacked, collapsible, defaultOpen = true, children }) {
    const [open, setOpen] = useState(defaultOpen);
    const isOpen = !collapsible || open;

    return (
        <div id={id} className={["ui-window-block", className, stacked ? 'is-stacked' : '', collapsible && 'is-collapsible', collapsible && isOpen && 'is-open'].join(" ").trim()}>
            <div
                className="ui-window-card-header"
                onClick={collapsible ? () => setOpen((current) => !current) : undefined}>
                <div className='ui-window-card-actions'>
                    {title && <p className='ui-window-card-title'>{title}</p>}
                    {subtitle && <p className='ui-window-card-subtitle'>{subtitle}</p>}
                </div>

                <div className='ui-window-card-actions'>
                    {primaryAction &&
                        <Button
                        badge={true}
                        icon={primaryAction.icon}
                        label={primaryAction.label}
                        loading={primaryAction.loading}
                        loadingText={primaryAction.loadingLabel}
                        onClick={() => primaryAction.onClick()} />
                    }

                    {secondaryAction &&
                        <Button
                        badge={true}
                        icon={secondaryAction.icon}
                        label={secondaryAction.label}
                        loading={secondaryAction.loading}
                        loadingText={secondaryAction.loadingLabel}
                        onClick={() => secondaryAction.onClick()} />
                    }

                    {collapsible &&
                        <button
                        type="button"
                        className="ui-window-card-collapse"
                        aria-label={isOpen ? "Collapse section" : "Expand section"}>
                            <CaretDownIcon />
                        </button>
                    }
                </div>
            </div>
            {isOpen && children}
        </div>
    );
}